[
  {
    "code": "IL-D",
    "name": "HaDarom"
  },
  {
    "code": "IL-M",
    "name": "HaMerkaz"
  },
  {
    "code": "IL-Z",
    "name": "HaZafon"
  },
  {
    "code": "IL-HA",
    "name": "Haifa"
  },
  {
    "code": "IL-TA",
    "name": "Tel-Aviv"
  },
  {
    "code": "IL-JM",
    "name": "Yerushalayim"
  }
]